
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

const BzModal = ({ onHide, centered = true, show = false, size, disableEscapeKey = false, ...props }) => {

    //BT-113338 Implementing header changes ManasaB : 15/07/2023 - Start
    const keyDown = useCallback((e) => {
        if (disableEscapeKey) {
            e.preventDefault();
        } else {
            return;
        }
    }, [disableEscapeKey]);
    //BT-113338 Implementing header changes ManasaB : 15/07/2023 - End

    return (
        //BT-113338 Implementing header changes ManasaB : 15/07/2023 added onEscapeKeyDown
        <Modal onEscapeKeyDown={keyDown} {...props} size={size} show={show} aria-labelledby="contained-model-title-vcenter" centered={centered} animation={false} scrollable={true} onHide={onHide}>
            {props.children}
        </Modal>
    );
};
BzModal.propTypes = {
    show: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'fullscreen']),
    centered: PropTypes.bool,
    onHide: PropTypes.func

};


export default memo(BzModal)
















